import Cookies from 'js-cookie';
import { checkXcx } from '@/utils/checkXcx';
import { AndroidMobile, iosMobile, unionFlag, checkUnifyShop, getXcxGioName } from '.';
import DFWebUtilsTools from '@df-fe/df-web-utils-tools';
import { BFD_checkApp } from './bfdApp';
import { safeJsonParse } from '@/utils/safeJsonParse';

const langText = require('./lang/language');
/**
 * gio埋点
 * @param { String } eventName // 事件名称
 * @param { Object } params // 参数
 */
export function sendGioData(eventName = 'DF_elementClick', params = {}) {
  const newParams = getCommonParams(params);
  try {
    gio('track', eventName, newParams);
    console.log(eventName, newParams);
    // debugger
  } catch (error) {
    console.log(error);
  }
}

export function getExchangePlatformCode() {
    let origin = window.location.origin;
    if (origin.indexOf('m-zx') > -1) {
      return '甄选';
    } else if (origin.indexOf('exchange') > -1) {
      return '产品册';
    } else if (origin.indexOf('corp') > -1) {
      return '百福得';
    } else {
      return '官网';
    }
  }

/** 获取公共入参 */
export function getCommonParams(moduleParams) {
  const unionF = unionFlagGio() || sessionStorage.getItem('dffl_union');
  const localAddress = safeJsonParse(DFWebUtilsTools.getCatchAddress());
  const address = localAddress || JSON.parse(getCookieGio('address')) || {};
  const { pathname, search } = location;
  const isOrder =
    window.location.pathname.indexOf('/orders') != -1 ||
    window.location.pathname.indexOf('/order/status');

  let platformInfo = 'h5';
  const lfFlag = Cookies.get('df_channel_source');
  if (BFD_checkApp()) {
    if (iosMobile()) {
      platformInfo = 'h5-IOS';
    }
    if (AndroidMobile()) {
      platformInfo = 'h5-Android';
    }
    // } else if (window?.DF_getCurrentField()) {
    //     platformInfo = getXcxGioName(window?.DF_getCurrentField());
  } else if (checkXcx()) {
    if (lfFlag && lfFlag == 'lf') {
      platformInfo = 'h5-乐福小程序';
    } else {
      platformInfo = 'h5-微信小程序';
    }
  }

  const params = {
    df_platform: platformInfo,
    df_versionNum: '',
    // 渠道
    df_source: (unionF && !checkUnifyShop()) ? '百福得' : '官网',
    // 频道
    df_channle: isOrder ? '' : '电影',
    // 前置页面名称
    df_prepageUrl: document.referrer || '',
    // 页面名称
    df_pagename: document.title || '',
    // 用户ID
    df_userid: getCookieGio('unionUserId') || getCookieGio('mall_userId') || '',
    // 用户ID
    df_city: address.cityName,
    // 事件时间
    df_activitytime: farmatDateGio(
      new Date(),
      'yyyy-MM-dd HH:mm:ss'
    ),
    // 英文版 当是英文版时传ture，中文版时传false
    df_isEnglish: !CheckCNGio(),
    // 兑换平台
    df_ExchangePlatform: getExchangePlatformCode()
  };

  const _params = { ...params, ...moduleParams };
  return _params;
}
/**
* 指定位置事件入参
* @param {*} type
*/
export function getGioParams(type) {
  const params = {};
  const localAddress = safeJsonParse(DFWebUtilsTools.getCatchAddress());
  const address = localAddress || JSON.parse(getCookieGio('address')) || {};
  let isType = type && type !== null && type !== undefined && type !== '';
  const priceFilterNmae = ['全部', '200以下', '200-300', '300-400', '400以上'].find((val) => val === (isType && type));
  switch (type) {
    case '点击联系客服':
      params.modulename = '联系客服';
      params.elementname = '点击联系客服';
      break;
    case '回到顶部':
      params.modulename = '右下角悬浮按钮';
      params.elementname = '回到顶部';
      break;
    case '购物车':
      params.modulename = '右下角悬浮按钮';
      params.elementname = '购物车';
      break;
    case '汉堡包':
      params.modulename = '顶部功能';
      params.elementname = '汉堡包';
      break;
    case '搜索':
      params.modulename = '顶部功能';
      params.elementname = '搜索';
      break;
    case '定位':
      params.modulename = '顶部功能';
      params.elementname = '定位';
      params.content = address.cityName;
      break;
    case '商城首页':
      params.modulename = '顶部功能';
      params.elementname = '商城首页';
      break;
    case '横向导航':
      params.modulename = '左侧频道导航';
      params.elementname = '横向导航';
      break;
    case '纵向导航':
      params.modulename = '左侧频道导航';
      params.elementname = '纵向导航';
      break;
    case '点击公告':
      params.modulename = '公告';
      params.elementname = '点击公告';
      break;
    case '点击轮播':
      params.modulename = '轮播';
      params.elementname = '点击轮播';
      break;
    case '点击首页':
      params.modulename = '底部导航';
      params.elementname = '点击首页';
      break;
    case '点击分类':
      params.modulename = '底部导航';
      params.elementname = '点击分类';
      break;
    case '点击我的':
      params.modulename = '底部导航';
      params.elementname = '点击我的';
      break;
    case '点击购物车':
      params.modulename = '底部导航';
      params.elementname = '点击购物车';
      break;
    // case '回到顶部':
    //     params.modulename = '右下角悬浮按钮';
    //     params.elementname = '回到顶部';
    //     break;
    case '回到购物车':
      params.modulename = '右下角悬浮按钮';
      params.elementname = '回到购物车';
      break;
    case '多规格面板加购':
      params.modulename = '商品列表';
      params.elementname = '多规格面板加购';
      break;
    case '点击加购物车':
      params.modulename = '商品列表';
      params.elementname = '点击加购物车';
      break;
    case '点击加分类页购物车':
      params.modulename = '列表商品';
      params.elementname = '点击加入购物车';
      break;
    case '分类Tab':
      params.modulename = '分类Tab';
      params.elementname = '分类Tab';
      break;
    case '更多分类':
      params.modulename = '分类Tab';
      params.elementname = '更多分类';
      break;
    case '二级分类':
      params.modulename = '分类Tab';
      params.elementname = '二级分类';
      break;
    case '分类':
      params.modulename = '分类Tab';
      params.elementname = '分类';
      break;
    case '浏览足迹Tab':
      params.modulename = '浏览足迹';
      params.elementname = '浏览足迹Tab';
      break;
    case '清空':
      params.modulename = '浏览足迹';
      params.elementname = '清空';
      break;
    case '点击商品':
      params.modulename = '浏览足迹';
      params.elementname = '点击商品';
      break;
    case '点击一级分类':
      params.modulename = '一级分类';
      params.elementname = '点击一级分类';
      break;
    case '点击二级分类':
      params.modulename = '二级分类';
      params.elementname = '点击二级分类';
      break;
    case '返回-顶部功能':
      params.modulename = '顶部';
      params.elementname = '返回';
      break;
    case '点击城市切换':
      params.modulename = '城市切换';
      params.elementname = '点击城市切换';
      break;
    case '点击更多分类':
      params.modulename = '更多分类';
      params.elementname = '点击更多分类';
      break;
    case '综合推荐':
      params.modulename = '综合排序';
      params.elementname = '综合推荐';
      break;
    case '销量由高到低':
      params.modulename = '综合排序';
      params.elementname = '销量由高到低';
      break;
    case '新品优先':
      params.modulename = '综合排序';
      params.elementname = '新品优先';
      break;
    case '热度优先':
      params.modulename = '综合排序';
      params.elementname = '热度优先';
      break;
    case '价格升序':
      params.modulename = '综合排序';
      params.elementname = '价格升序';
      break;
    case '价格降序':
      params.modulename = '综合排序';
      params.elementname = '价格降序';
      break;
    case '点击品牌':
      params.modulename = '品牌筛选';
      params.elementname = '点击品牌';
      break;
    case '确定':
      params.modulename = '其他筛选';
      params.elementname = '确定';
      break;
    case '点击商品-活动':
      params.modulename = '列表商品';
      params.elementname = '点击商品';
      break;
    case '价格筛选':
      params.modulename = '价格筛选';
      params.elementname = '价格筛选';
      break;
    case priceFilterNmae:
      params.modulename = '价格筛选';
      params.elementname = type;
      break;
    case '普通楼层-点击商品':
      params.modulename = '普通楼层';
      params.elementname = '点击商品';
      break;
    case '普通楼层-点击加购物车':
      params.modulename = '普通楼层';
      params.elementname = '点击加购物车';
      break;
    case '普通楼层-加入购物车':
      params.modulename = '普通楼层';
      params.elementname = '多规格面板加购';
      break;
    case 'kv图':
      params.modulename = 'kv图';
      params.elementname = 'kv图';
      break;
    case '查看更多':
      params.modulename = '查看更多';
      params.elementname = '查看更多';
      break;
    case '顶部导航':
      params.modulename = '顶部导航';
      params.elementname = '顶部导航';
      break;
    case '楼层导航':
      params.modulename = '楼层导航';
      params.elementname = '楼层导航';
      break;
    case '规格':
      params.modulename = '多规格面板';
      params.elementname = '规格';
      break;
    case '数量':
      params.modulename = '多规格面板';
      params.elementname = '数量';
      break;
    case '加入购物车':
      params.modulename = '多规格面板';
      params.elementname = '加入购物车';
      break;
    case '立即购买':
      params.modulename = '多规格面板';
      params.elementname = '立即购买';
      break;
    case '关闭':
      params.modulename = '多规格面板';
      params.elementname = '关闭';
      break;
    case '点击综合':
      params.modulename = '排序筛选';
      params.elementname = '点击综合';
      break;
    case '点击品牌tab':
      params.modulename = '排序筛选';
      params.elementname = '点击品牌';
      break;
    case '点击其他筛选':
      params.modulename = '排序筛选';
      params.elementname = '点击其他筛选';
      break;
    case '分类标题':
      params.modulename = '商品列表';
      params.elementname = '分类标题';
      break;
    case '返回':
      params.modulename = '顶部';
      params.elementname = '返回';
      break;
    case '点击分类商品':
      params.modulename = '列表商品';
      params.elementname = '点击商品';
      break;
    case '点击首页商品':
      params.modulename = '商品列表';
      params.elementname = '列表商品';
      break;
    case '商品详情-优惠活动':
      params.modulename = '优惠活动';
      params.elementname = '';
      break;
    case '商品详情-规格':
      params.modulename = '规格';
      params.elementname = '';
      break;
    case '商品详情-配送':
      params.modulename = '配送';
      params.elementname = '';
      break;
    case '底部功能-点击联系客服':
      params.modulename = '底部功能区';
      params.elementname = '点击联系客服';
      break;
    case '底部功能-购物车':
      params.modulename = '底部功能区';
      params.elementname = '购物车';
      break;
    case '底部功能-加入购物车':
      params.modulename = '底部功能区';
      params.elementname = '加入购物车';
      break;
    case '底部功能-立即购买':
      params.modulename = '底部功能区';
      params.elementname = '立即购买';
      break;
    case '优惠活动浮窗-关闭':
      params.modulename = '优惠活动浮窗';
      params.elementname = '关闭';
      break;
    case '优惠活动浮窗-满减':
      params.modulename = '优惠活动浮窗';
      params.elementname = '满减';
      break;
    case '优惠活动浮窗-优惠券':
      params.modulename = '优惠活动浮窗';
      params.elementname = '优惠券';
      break;
    case '收货信息弹窗-选择收货地址':
      params.modulename = '收货信息弹窗';
      params.elementname = '选择收货地址';
      break;
    case '收货信息弹窗-新建收货地址':
      params.modulename = '收货信息弹窗';
      params.elementname = '新建收货地址';
      break;
    case '收货信息弹窗-关闭':
      params.modulename = '收货信息弹窗';
      params.elementname = '关闭';
      break;
    case '商品详情-商品推荐':
      params.modulename = '商品推荐';
      params.elementname = '点击商品';
      break;
    case '商品详情顶部-商品':
      params.modulename = '顶部Tab';
      params.elementname = '商品';
      break;
    case '商品详情顶部-详情':
      params.modulename = '顶部Tab';
      params.elementname = '详情';
      break;
    case '商品详情顶部-推荐':
      params.modulename = '顶部Tab';
      params.elementname = '推荐';
      break;
    case '购物车-收货地址':
      params.modulename = '收货信息';
      params.elementname = '收货地址';
      break;
    case '购物车-编辑':
      params.modulename = '购物车编辑';
      params.elementname = '编辑';
      break;
    case '购物车-完成':
      params.modulename = '购物车编辑';
      params.elementname = '完成';
      break;
    case '购物车-全选':
      params.modulename = '购物车编辑';
      params.elementname = '全选';
      break;
    case '购物车-删除':
      params.modulename = '购物车编辑';
      params.elementname = '删除';
      break;
    case '购物车-营销-优惠券':
      params.modulename = '营销模块';
      params.elementname = '领券优惠券';
      break;
    case '购物车-营销-满减':
      params.modulename = '营销模块';
      params.elementname = '满减凑单';
      break;
    case '购物车-领券弹窗-关闭':
      params.modulename = '领券弹窗';
      params.elementname = '关闭';
      break;
    case '购物车-领券弹窗-优惠券':
      params.modulename = '领券弹窗';
      params.elementname = '优惠券';
      break;
    case '空购物车':
      params.modulename = '空购物车';
      params.elementname = '去商城首页';
      break;
    case '购物车-点击商品':
      params.modulename = '购物车商品';
      params.elementname = '点击商品';
      break;
    case '购物车-商品-删除':
      params.modulename = '购物车商品';
      params.elementname = '删除';
      break;
    case '购物车-去结算':
      params.modulename = '结算';
      params.elementname = '去结算';
      break;
    case '购物车-失效商品-清空':
      params.modulename = '失效商品';
      params.elementname = '清空';
      break;
    case '购物车-失效商品-再想想':
      params.modulename = '失效商品';
      params.elementname = '再想想';
      break;
    case '购物车-失效商品-确认清空':
      params.modulename = '失效商品';
      params.elementname = '确认清空';
      break;
    case '订单确认-收货地址':
      params.modulename = '收货信息';
      params.elementname = '收货地址';
      break;
    case '订单确认-收货地址-编辑':
      params.modulename = '收货信息';
      params.elementname = '编辑收货地址';
      break;
    case '订单确认-收货地址-删除':
      params.modulename = '收货信息';
      params.elementname = '删除';
      break;
    case '订单确认-收货地址-新建':
      params.modulename = '新建收货地址';
      params.elementname = '新建收货地址';
      break;
    // case '订单确认-收货地址-删除':
    //     params.modulename = '删除';
    //     params.elementname = '';
    //     break;
    case '信息编辑-收货人':
      params.modulename = '信息编辑';
      params.elementname = '收货人';
      break;
    case '信息编辑-手机号码':
      params.modulename = '信息编辑';
      params.elementname = '手机号码';
      break;
    case '信息编辑-所在地址':
      params.modulename = '信息编辑';
      params.elementname = '所在地址';
      break;
    case '信息编辑-详细地址':
      params.modulename = '信息编辑';
      params.elementname = '详细地址';
      break;
    case '信息编辑-地址标签':
      params.modulename = '信息编辑';
      params.elementname = '地址标签';
      break;
    case '信息编辑-设为默认':
      params.modulename = '信息编辑';
      params.elementname = '设为默认';
      break;
    case '保存地址':
      params.modulename = '保存地址';
      params.elementname = '保存地址';
      break;
    case '订单确认-期望发货时间':
      params.modulename = '期望发货时间';
      params.elementname = '期望发货时间';
      break;
    case '订单确认-提交订单':
      params.modulename = '下单';
      params.elementname = '提交订单';
      break;
    case '订单确认-优惠券':
      params.modulename = '优惠券';
      params.elementname = '优惠券';
      break;
    case '订单确认-优惠券浮窗-状态Tab':
      params.modulename = '优惠券浮窗';
      params.elementname = '状态Tab';
      break;
    case '订单确认-优惠券浮窗-选择优惠券':
      params.modulename = '优惠券浮窗';
      params.elementname = '选择优惠券';
      break;
    case '订单确认-优惠券浮窗-确定':
      params.modulename = '优惠券浮窗';
      params.elementname = '确定';
      break;
    case '订单确认-优惠券浮窗-关闭浮窗':
      params.modulename = '优惠券浮窗';
      params.elementname = '关闭浮窗';
      break;
    case '订单确认-优惠劵':
      params.modulename = '优惠劵';
      params.elementname = '优惠劵';
      break;
    case '订单确认-福利卡':
      params.modulename = '福利卡';
      params.elementname = '福利卡';
      break;
    case '订单确认-账户余额':
      params.modulename = '账户余额';
      params.elementname = '账户余额';
      break;
    case '订单确认-账户积分':
      params.modulename = '账户积分';
      params.elementname = '账户积分';
      break;
    case '确认订单页-福利卡浮窗-使用范围':
      params.modulename = '福利卡浮窗';
      params.elementname = '使用范围';
      break;
    case '确认订单页-福利卡浮窗-黄牛浮窗':
      params.modulename = '福利卡浮窗';
      params.elementname = '黄牛浮窗';
      break;
    case '订单确认-设置支付密码-立即设置':
      params.modulename = '设置支付密码';
      params.elementname = '立即设置';
      break;
    case '订单确认-设置支付密码-关闭立即设置':
      params.modulename = '设置支付密码';
      params.elementname = '关闭立即设置';
      break;
    case '订单确认-设置支付密码-返回':
      params.modulename = '设置支付密码';
      params.elementname = '返回';
      break;
    case '订单确认-设置支付密码-重发验证码':
      params.modulename = '设置支付密码';
      params.elementname = '重发验证码';
      break;
    case '订单确认-设置支付密码-重新输入':
      params.modulename = '设置支付密码';
      params.elementname = '重新输入';
      break;
    case '订单确认-退出密码设置-退出':
      params.modulename = '退出密码设置';
      params.elementname = '退出';
      break;
    case '订单确认-退出密码设置-设置密码':
      params.modulename = '退出密码设置';
      params.elementname = '设置密码';
      break;
    case '订单确认-输入支付密码-返回':
      params.modulename = '输入支付密码';
      params.elementname = '返回';
      break;
    case '订单确认-输入支付密码-忘记密码':
      params.modulename = '输入支付密码';
      params.elementname = '忘记密码';
      break;
    case '订单确认-绑定手机-返回':
      params.modulename = '绑定手机';
      params.elementname = '返回';
      break;
    case '订单确认-绑定手机-发送验证码':
      params.modulename = '绑定手机';
      params.elementname = '发送验证码';
      break;
    case '订单确认-新人引导':
      params.modulename = '新人引导';
      params.elementname = '新人引导';
      break;
    case '订单确认-抵扣失败弹框-重新选择':
      params.modulename = '抵扣失败弹框';
      params.elementname = '重新选择';
      break;
    case '订单确认-抵扣失败弹框-关闭浮窗':
      params.modulename = '抵扣失败弹框';
      params.elementname = '关闭浮窗';
      break;
    case '商品失效弹框-知道了':
      params.modulename = '商品失效弹框';
      params.elementname = '知道了';
      break;
    case '商品失效弹框-返回':
      params.modulename = '商品失效弹框';
      params.elementname = '返回';
      break;
    case '未使用弹框-去使用':
      params.modulename = '未使用弹框';
      params.elementname = '去使用';
      break;
    case '未使用弹框-提交订单':
      params.modulename = '未使用弹框';
      params.elementname = '提交订单';
      break;
    case '支付成功-继续逛逛':
      params.modulename = '支付成功';
      params.elementname = '继续逛逛';
      break;
    case '支付成功-查看订单':
      params.modulename = '支付成功';
      params.elementname = '查看订单';
      break;
    case '支付失败-重新支付':
      params.modulename = '支付失败';
      params.elementname = '重新支付';
      break;
    case '支付失败-查看订单':
      params.modulename = '支付失败';
      params.elementname = '查看订单';
      break;
    case '账户入口':
      params.modulename = '账户入口';
      params.elementname = '';
      break;
    case '账户设置':
      params.modulename = '设置';
      params.elementname = '';
      break;
    case '我的卡券-点击添加新卡':
      params.modulename = '我的卡券';
      params.elementname = '点击添加新卡';
      break;
    case '我的卡券-可用福利卡':
      params.modulename = '我的卡券';
      params.elementname = '可用福利卡';
      break;
    case '我的卡券-不可用福利卡':
      params.modulename = '我的卡券';
      params.elementname = '不可用福利卡';
      break;
    case '我的卡券-优惠券':
      params.modulename = '我的卡券';
      params.elementname = '优惠券';
      break;
    case '健康权益':
      params.modulename = '健康权益';
      params.elementname = '';
      break;
  }
  return params;
}

/**
* 获取cookie
* @param {String} sKey 获取cookie对应的名字
* @return {String | Object}
*/
function getCookieGio(sKey) {
  return (decodeURIComponent(
    document.cookie.replace(
      /* eslint-disable-next-line */
      new RegExp(
        '(?:(?:^|.*;)\\s*' +
        encodeURIComponent(sKey).replace(/[-.+*]/g, '\\$&') +
        '\\s*\\=\\s*([^;]*).*$)|^.*$'
      ),
      '$1'
    )
  ) || null);
}

function unionFlagGio() {
  let currentUnionValue;
  const union = getQueryStringGio('union');
  const { hostname, pathname } = window.location;
  if (union) {
    // URI带union参数的判断是工会链接
    return union;
  }
  if (/^corp/.test(pathname) && pathname.match(/union\/\w+/g)) {
    // 测试环境http://corp.m.test03.com/union/lifangfang02/user/login
    currentUnionValue = pathname.match(/union\/\w+/g)[0].split('/')[1];
  } else {
    // 正式环境http://www.dbenefit.dongfangfuli.com/bfd_pc/index?union=dbenefit&city=2
    // 测试环境http://union.testzhou.zhouweiwei.qa.psf-dev.com/
    // k8s测试环境http://www.lifangfang02.test01.com/drama_pc/home?city=145&mc=Shows
    // stage环境http://www.rjh.stage.dongfangfuli.com/shop/home?city=145&mc=Shopping
    if (
      ((window.location.href.indexOf('test05') > -1 || window.location.href.indexOf('stage') > -1) && /^(?:union)/.test(hostname)) ||
      /^(?:w{3})\.((?!stage)[A-Za-z1-9]{1}(\w|-)+\.)(stage\.)?(\w+\.)(?=com)/.test(
        hostname
      )
    ) {
      currentUnionValue = hostname.split('.')[1];
    } else {
      currentUnionValue = '';
    }

    return currentUnionValue;
  }
}

/**
* 获取请求参数名对应的值
* @param  {String} name 参数名字
* @return {String}
*/
function getQueryStringGio(name) {
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
  const res = window.location.search.substr(1).match(reg);
  if (res !== null) return window.decodeURIComponent(res[2]);
  return '';
}



/**
* 时间格式化
* @param { date } date // 时间
* @param { string } fmt  // 格式化格式
* @return { String }  提示文案
*/
function farmatDateGio(date, fmt) {
  const o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'H+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds(),
    'q+': Math.floor((date.getMonth() + 3) / 3),
    S: date.getMilliseconds()
  };
  let year = date.getFullYear().toString();
  year = year.length >= 4 ? year : '0000'.substr(0, 4 - year.length) + year;

  if (/(y+)/.test(fmt))
    fmt = fmt.replace(RegExp.$1, (year + '').substr(4 - RegExp.$1.length));
  for (const k in o)
    if (new RegExp('(' + k + ')').test(fmt))
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
      );
  return fmt;
}

/**
* 判断是否是中文
*/
function CheckCNGio() {
  /** 输入中文，根据Cookie: df_lang=zh-CN中文，默认中文; df_lang=en-US英文; */
  let dfLang = getCookieGio('df_lang') || '';
  const union = unionFlag() || window.sessionStorage.getItem('dffl_union');
  // 兼容历史逻辑
  const { union_isBilingual } = window;
  // 未读取到多语言源文件或无语言设置直接返回默认值
  if (!langText) {
    return currentLang;
  }
  if (union_isBilingual) {
    dfLang = 'en';
  } else if (!union) {
    dfLang = 'cn';
  } else if (dfLang) {
    switch (dfLang) {
      case 'zh-CN':
        dfLang = 'cn';
        break;
      case 'en-US':
        dfLang = 'en';
        break;
      default:
        break;
    }

  } else {
    dfLang = 'cn';
  }
  return dfLang === 'cn';
}

// 页面进入
// var initTime;
// window.onload = function (e) {
//     initTime = farmatDateGio(
//         new Date(),
//         "yyyy.MM.dd HH:mm:ss"
//     )
// }
// window.onbeforeunload = function (e) {
//     let closeTime = farmatDateGio(
//         new Date(),
//         "yyyy.MM.dd HH:mm:ss"
//     )
//     const date1 = new Date(initTime)
//     const date2 = new Date(closeTime)
//     const date3 = date2.getTime() - new Date(date1).getTime() / 1000;
//     console.log(date3)
//     var e = window.event || e;
//     e.returnValue = ("确定离开当前页面吗？");
// }
